import { DefaultFactory } from "./DefaultFactory";
import { DirectGeometry } from "./DirectGeometry";
import { Face3 } from "./Face3";
import { Gmetry } from "./Gmetry";
export const ThreeGeometryHellfix = {
    DirectGeometry,
    Face3,
    Gmetry,
    DefaultFactory
};
//# sourceMappingURL=mylibrary.js.map